export const rowId: unique symbol = Symbol('rowId');
export const DATA_TABLE_KEY: unique symbol = Symbol('DATA_TABLE_KEY');
